module.exports = "images/6ans.f82b2357.png";